// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

import { MoneyFragmentDoc } from '../../../fragments/money.fragment.generated';
export const NonSkuPriceRangeFragmentDoc = `
    fragment nonSkuPriceRange on NonSkuPriceRange {
  __typename
  min {
    ...money
  }
  max {
    ...money
  }
}
    `;